import { render, staticRenderFns } from "./EditarBanco.vue?vue&type=template&id=5c12e95d&"
import script from "./EditarBanco.vue?vue&type=script&lang=ts&"
export * from "./EditarBanco.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports